var ChangedLeaguesModifier = /** @class */ (function () {
    function ChangedLeaguesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    ChangedLeaguesModifier.prototype.modify = function (content) {
        if (content.leagues === undefined || content.leagues.change === undefined) {
            return;
        }
        var leagues = content.leagues.change;
        for (var i = 0; i < leagues.length; i++) {
            var league = leagues[i];
            var key = this._modelKeyRepository.getLeagueKey(league.id);
            leagues[i] = Object.assign({
                name: league.n,
                priority: league.p
            }, key);
        }
    };
    return ChangedLeaguesModifier;
}());
export default ChangedLeaguesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/ChangedLeaguesModifier.js